import { iIconProps } from '../icon';

export default function ExternalLinkIcon({ size, ...props }: iIconProps): JSX.Element {
    return (
        <svg width={size} height={size} viewBox='0 0 24 24' {...props}>
            <path
                d='M12 21.75c-4.44 0-6.67 0-8.21-1.54S2.25 16.44 2.25 12s0-6.67 1.54-8.21c1.46-1.46 3.62-1.53 7.31-1.54.41 0 .75.33.75.75s-.33.75-.75.75c-3.59 0-5.27.11-6.25 1.1-1.1 1.1-1.1 3.12-1.1 7.15s0 6.05 1.1 7.15 3.12 1.1 7.15 1.1 6.05 0 7.15-1.1c.99-.99 1.09-2.66 1.1-6.25 0-.41.34-.75.75-.75s.75.34.75.75c0 3.7-.08 5.86-1.54 7.31-1.54 1.54-3.77 1.54-8.21 1.54'
                fill='currentColor'
            />
            <path
                d='M11.05 13.81c-.19 0-.38-.07-.53-.22a.754.754 0 0 1 0-1.06l8.58-8.64c-.6-.06-1.56-.11-3.06-.08-.41 0-.75-.33-.76-.74 0-.41.33-.75.74-.76 4.34-.06 4.82.41 5.07.66s.71.73.65 5.07c0 .41-.35.72-.76.74a.75.75 0 0 1-.74-.76c.02-1.5-.02-2.45-.08-3.06l-8.58 8.63c-.15.15-.34.22-.53.22'
                fill='currentColor'
            />
        </svg>
    );
}
